module.exports = __webpack_public_path__ + "static/media/1.98ae42f6.jpg";